const { getElement, getElements } = window.BAO.Utils

export class SiteModals extends window.BAO.CustomElement() {
  constructor () {
    super()

    if (this.hasAlreadyBeenUsed) {
      throw new Error(
        `You can only use 1 instance of ${this.nodeName.toLowerCase()}`,
      )
    }

    this._activeModalKey = ''

    window.modals = this

    this.modalKeys
      .filter((key) => !this.triggerKeys.includes(key))
      .forEach((key) =>
        console.info(`Modal exists for ${key} but there is no trigger`),
      )
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(
      document.documentElement,
      'click',
      this.handleClick.bind(this),
    )

    this.listeners.add(document.documentElement, 'keydown', (e) => {
      if (e.key === 'Escape') {
        this.activeModalKey = ''
      }
    })
  }

  handleClick (e) {
    const EVENTS = {
      TRIGGER: 'TRIGGER',
      CLOSE: 'CLOSE',
      BACKDROP: 'BACKDROP',
      UNKNOWN: 'UNKNOWN',
    }
    const eventType = (() => {
      if (e.target.closest(this.config.matches.trigger) !== null) {
        return EVENTS.TRIGGER
      } else if (e.target.closest(this.config.matches.close) !== null) {
        return EVENTS.CLOSE
      } else if (e.target.closest(this.config.matches.modal) !== null) {
        if (e.detail !== 0) {
          const dialogDimensions = e.target
            .closest(this.config.matches.modal)
            .getBoundingClientRect()

          if (
            e.clientX < dialogDimensions.left ||
            e.clientX > dialogDimensions.right ||
            e.clientY < dialogDimensions.top ||
            e.clientY > dialogDimensions.bottom
          ) {
            return EVENTS.BACKDROP
          }
        }
      }

      return EVENTS.UNKNOWN
    })()

    if (eventType === EVENTS.UNKNOWN) return
    e.preventDefault()

    if (eventType === EVENTS.TRIGGER) {
      const trigger = e.target.closest(this.config.matches.trigger)
      const key = trigger.getAttribute('data-modals-trigger')

      this.activeModalKey = key === this.activeModalKey ? '' : key
    }

    if (eventType === EVENTS.CLOSE || eventType === EVENTS.BACKDROP) {
      this.activeModalKey = ''
    }
  }

  /**
   * @param {string} key
   */
  open (key) {
    this.activeModalKey = key
  }

  close () {
    this.activeModalKey = ''
  }

  get triggerKeys () {
    return getElements('[data-modals-trigger]').map((el) =>
      el.getAttribute('data-modals-trigger'),
    )
  }

  get modalKeys () {
    return this.modalEls.map((el) => el.getAttribute('key'))
  }

  get hasAlreadyBeenUsed () {
    const el = getElement(this.nodeName.toLowerCase())

    return el !== this
  }

  get aModalIsOpen () {
    return this.modalEls.some((modal) => modal.isOpen)
  }

  get modalEls () {
    return Array.from(document.querySelectorAll(this.config.matches.modal))
  }

  get activeModalKey () {
    return this._activeModalKey
  }

  set activeModalKey (key) {
    const prevKey = this._activeModalKey
    this._activeModalKey = key

    this.modalEls.forEach((modal) => (modal.isOpen = modal.key === key))

    document.body.classList.toggle(
      this.config.classes.siteOverflowed,
      this.aModalIsOpen,
    )

    if (prevKey) {
      document.body.classList.remove(`mod-Modals-${prevKey}`)
    }

    if (key !== '') {
      document.body.classList.add(`mod-Modals-${key}`)
    }

    document.dispatchEvent(new CustomEvent('modal-changed'))
  }

  get config () {
    return {
      matches: {
        trigger: '[data-modals-trigger]',
        close: '[data-modals-close]',
        modal: '[is="site-modal"]',
      },
      classes: {
        siteOverflowed: 'util-SiteOverflowed',
      },
    }
  }
}

customElements.define('site-modals', SiteModals)
